import React, { useRef } from "react";
import { Box, Typography, Button } from "@mui/material";
import HowToClaim from "./howToClaim";
import trophyIcon from "../../assets/icons/trophy.png";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

// Placeholder component when prizeWon === "noprize"
const NoPrizePlaceholder = () => (
  <Box textAlign="center" p={4} mb={3}>
    <img
      src={trophyIcon}
      alt="No Prize"
      style={{ width: 300, height: 300, marginBottom: 16 }}
    />
    <Typography variant="h6" fontWeight="bold" gutterBottom>
      Thank you for joining
    </Typography>
    <Typography variant="body2">Raffle draw is finished. Thank you for joining the event!</Typography>
  </Box>
);

const PrizeWonCard = ({ prizeWon }) => {
  const claimRef = useRef(null);

  if (!prizeWon) return null;
  if (prizeWon === "noprize") return <NoPrizePlaceholder />;

  // Scroll to HowToClaim section
  const handleScroll = () => {
    claimRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box textAlign="center" mb={3}>
      {/* Prize Image */}
      <Carousel showThumbs={false} infiniteLoop>
        {prizeWon?.image?.map((item, index) => {
          return (
            <Box key={index} component="img" height="200"
              sx={{ borderRadius: 2, width: '100%', height: 300, objectFit: "contain" }}
              src={item !== "" ? item.image[0].url : "https://png.pngtree.com/png-vector/20230311/ourmid/pngtree-trophy-line-icon-vector-png-image_6644522.png"}
              alt={`Prize image ${index + 1}`}
            />
          )
        })}
      </Carousel>

      {/* Prize Text */}
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        You win an {prizeWon.title}
      </Typography>
      <Typography variant="body2" mb={2}>
        We sent you an email with a QR code. <br /> Present this to the event admin.
      </Typography>

      {/* Scroll Button */}
      <Button
        variant="outlined"
        sx={{ borderRadius: 10, textTransform: "none", px: 4 }}
        onClick={handleScroll}
      >
        Learn how to claim
      </Button>

      {/* HowToClaim section */}
      <Box mt={6} ref={claimRef}>
        <HowToClaim />
      </Box>
    </Box>
  );
};

export default PrizeWonCard;
